import { FILE_TYPE_MAP, ALLOWED_FILE_TYPES, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB } from "../config/fileTypes";

// Convert DB rows (filesNeeded) to fileConfig objects for FileUploadRow
export function mapDbFilesToConfigs(dbFiles, fileTypeMappings) {
  if (!dbFiles || !Array.isArray(dbFiles)) return [];
  return dbFiles
    .filter((row) => row.active == 1 || row.uploaded == 1)
    .map((row) => {
      const typeConfig = FILE_TYPE_MAP[row.file_id] || { label: "Document" };
      return {
        value: row.id,
        fileId: row.file_id,
        label: (fileTypeMappings && fileTypeMappings?.find(file => file.value == row.file_id)?.label) ?? "Document",
        helperText: typeConfig.helperText,
        required: row.required,
        path: row.file_path,
        active: row.active,
        uploaded: row.uploaded
      };
    });
}

export function validateFile(file) {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return {
      valid: false,
      message: "Only PDF files are allowed.",
    };
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      valid: false,
      message: `File must be smaller than ${MAX_FILE_SIZE_MB}MB.`,
    };
  }
  return { valid: true };
}

